import { render, staticRenderFns } from "./MissingDataReminder.vue?vue&type=template&id=10fd350c&scoped=true&"
import script from "./MissingDataReminder.vue?vue&type=script&lang=js&"
export * from "./MissingDataReminder.vue?vue&type=script&lang=js&"
import style0 from "./MissingDataReminder.vue?vue&type=style&index=0&id=10fd350c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fd350c",
  null
  
)

export default component.exports